The details of what will be paid for an advertisement product.
